/**
 * <delivery-promise data-cutoff="18" data-days-off="" data-time-zone="Asia/Kuwait">
 * When the order arrives, by the clock in Kuwait. The page already says the line that is always
 * true; this writes the one for this minute, and keeps it right while the page stays open.
 * Used in the bag and in the delivery list on the product page (snippets/delivery-promise.liquid).
 *
 *   more than three hours before the last hour   data-before, or the line the page came with
 *   fewer than three hours                       data-countdown, with the time left
 *   after the last hour                          data-tomorrow
 *   tomorrow is a day with no delivery           data-day, with the name of the day
 */
const Kanze = (window.Kanze = window.Kanze || {});

class DeliveryPromise extends HTMLElement {
  connectedCallback() {
    this.line = this.querySelector('[data-promise]');
    if (!this.line) return;
    this.write();
    this.timer = window.setInterval(() => this.write(), 20000);
  }

  disconnectedCallback() {
    window.clearInterval(this.timer);
  }

  /** The date and the time of day in Kuwait, whatever the customer's own time zone is. */
  now() {
    try {
      const parts = new Intl.DateTimeFormat('en-GB', { timeZone: this.dataset.timeZone, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
      const read = (type) => Number(parts.find((part) => part.type === type).value);
      return { noon: Date.UTC(read('year'), read('month') - 1, read('day'), 12), minutes: read('hour') * 60 + read('minute') };
    } catch (error) {
      return null;
    }
  }

  write() {
    const now = this.now();
    if (!now) return;
    const digits = Kanze.digits || String;
    const cutoff = Number(this.dataset.cutoff) * 60;
    const daysOff = this.dataset.daysOff || '';
    const DAY = 86400000;
    // Days until the first day with delivery, counting from today (before the hour) or tomorrow.
    let wait = now.minutes >= cutoff ? 1 : 0;
    for (let step = 0; step <= 7; step += 1) {
      if (!daysOff.includes(String(new Date(now.noon + (wait + step) * DAY).getUTCDay()))) {
        wait += step;
        break;
      }
    }
    const left = cutoff - now.minutes;
    let html = '';
    if (wait === 0 && left < 180) {
      const hours = Math.floor(left / 60);
      const minutes = left % 60;
      const time = [hours ? `${digits(hours)} ${this.dataset.hours}` : '', minutes || !hours ? `${digits(minutes)} ${this.dataset.minutes}` : ''].filter(Boolean).join(' ');
      html = this.dataset.countdown.replace('[time]', time);
    } else if (wait === 0) {
      // More than three hours to go. Without this line, the one the page came with is right.
      html = this.dataset.before || '';
    } else if (wait === 1) {
      html = this.dataset.tomorrow;
    } else {
      const language = (document.documentElement.lang || 'en').replace(/^en$/, 'en-GB');
      html = this.dataset.day.replace('[day]', new Intl.DateTimeFormat(language, { weekday: 'long', timeZone: 'UTC' }).format(now.noon + wait * DAY));
    }
    if (html && html !== this.written) {
      this.written = html;
      this.line.innerHTML = html;
    }
  }
}

if (!customElements.get('delivery-promise')) customElements.define('delivery-promise', DeliveryPromise);
